import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateContact } from '../../../../actions/personalInfoAction';
import {isMobile} from 'react-device-detect';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import EmailFields from '../../../../components/Fields/EmailFields';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import {PERSONALINFO_EMAIL} from '../../../../utils/FieldTypes';

class InlineEditEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };
    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  onClickSave(event) {
    event.preventDefault();
    this.props.validatePersonalInfoFields(["email"], (isValid) => {
      if(isValid) {
        // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
        // Added the correct property names
        this.props.updateContact(this.props.email, this.props.savedPersonalInfo.mobilePhone, this.props.savedPersonalInfo.homePhone, this.props.savedPersonalInfo.accountPassword);
        this.toggleEdit();
      }
      else {
        this.setState({
          saveDialogOpen: false
        })
      }
    });
  }
  cancelEdit() {
    if(this.props.email === this.props.savedPersonalInfo.email) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(PERSONALINFO_EMAIL);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }
  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    let email = this.props.savedPersonalInfo.email;

    if(email === "") {
      email = "no email provided";
    }
    return (
      <div className="review-inline-edit">
        {!this.state.edit ?
          <StaticField label="Email" value={email} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />      
        :
          <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>  
            <EmailFields handleChange={this.props.handleChange} validateField={this.props.validateField}  {...this.props} autoFocus={!isMobile}  />
          </InlineEdit>
        }
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Personal Info" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
  updateContact: (email, mobilePhone, homePhone, accountPassword) => dispatch(updateContact(email, mobilePhone, homePhone, accountPassword))
})


export default connect(mapStateToProps, mapDispatchToProps)(InlineEditEmail);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/PersonalInfo/Email.js